module.exports = __webpack_public_path__ + "img/collectible-card-total-background.aa0b10ea.svg";